import cns from 'classnames'
import { Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { useLocalStorage } from 'shared/hooks/useLocalStorage'
import { useRouteMeta } from 'modules/router/hooks/useRouteMeta'
import { useDisclaimerModal } from './DisclaimerModal'
import { useFirebase } from 'modules/analytics/firebase'

import { AppWrap } from '../AppWrap'
import { AppInner } from '../AppInner'
import { Drawer } from '../Drawer'
import { Title } from 'shared/ui/common/Title'
import { HeaderActions } from '../HeaderActions'
import { Footer } from '../Footer'
import { UnsupportedChainBanner } from 'shared/ui/layout/UnsupportedChainBanner'

import { LS_KEY_SKIP_DISCLAIMER } from './DisclaimerModal/constants'
import { DISCLAIMER_SHOWN_EVENT } from 'modules/analytics/events'
import s from './AppLayout.module.scss'

export function AppLayout() {
  const routeMeta = useRouteMeta()
  const [shouldShowDisclaimer] = useLocalStorage(LS_KEY_SKIP_DISCLAIMER, '0')
  const disclaimerModal = useDisclaimerModal()
  const { trackEvent } = useFirebase()
  const isNarrow = routeMeta.layoutType === 'narrow'
  const isNarrowExtended = routeMeta.layoutType === 'narrow-extended'
  const headerTitle = routeMeta.headerTitle

  useEffect(() => {
    if (shouldShowDisclaimer !== '1') {
      trackEvent(DISCLAIMER_SHOWN_EVENT)
      disclaimerModal.open({})
    }
  }, [disclaimerModal, shouldShowDisclaimer, trackEvent])

  return (
    <>
      <UnsupportedChainBanner />
      <AppWrap
        className={cns(s.wrap, {
          [s.isNarrow]: isNarrow,
          [s.isNarrowExtended]: isNarrowExtended,
        })}
      >
        <AppInner className={s.appInner}>
          <Drawer className={s.drawer} />
          <HeaderActions />
          <div className={s.content}>
            <Title>{headerTitle}</Title>
            <Outlet />
          </div>
        </AppInner>
        <Footer />
      </AppWrap>
    </>
  )
}
